import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'antd';
import menu from '../../img/default-svg/menu.svg';
import menuInex from '../../img/inex/menu.svg';
import menuInsta from '../../img/instaXchange/menu.svg';
import menuCoinera from '../../img/coinera/menu.svg';
import logoCpay from '../../img/footer/footerLogo.svg';
import logoPayblock from '../../img/footer/payblock-logo.png';
import logoNfg from '../../img/nfgpay-svg/nfg_logo_black.svg';
import logoFinvaro from '../../img/finvaro/finvaro-logo-black.png';
import logoClarnium from '../../img/clarnium/clarnium-logo-color.png';
import logoInex from '../../img/inex/inex-logo.svg';
import logoInsta from '../../img/instaXchange/instaXchange-logo.png';
import logoCoinera from '../../img/coinera/coinera-logo.png';
import HeaderUser from '../components/HeaderUser/HeaderUser';
import NetworkFilter from '../../components/NetworkFilter';
import './Header.scss';
import { AppConfig } from '../../config';
import { identity } from '../../utils/getIdentity';

const menuIcon = {
  cpay: menu,
  nfg: menu,
  finvaro: menu,
  clarnium: menu,
  inex: menuInex,
  insta: menuInsta,
  coinera: menuCoinera
}

const logos = {
  cpay: !AppConfig?.hideLogo ? logoCpay : logoPayblock,
  nfg: logoNfg,
  finvaro: logoFinvaro,
  clarnium: logoClarnium,
  inex: logoInex,
  insta: logoInsta,
  coinera: logoCoinera
};

function Header({ toggleCollapseSider }) {
  return (
    <div className={`admin-header admin-header-${identity}`}>
      <Row align="middle" gutter={[32, 0]}>
        <Col flex="90px">
          <span className="admin-header__toggle-sider" onClick={toggleCollapseSider}>
            <img src={menuIcon[identity]} alt="menu" />
          </span>
        </Col>
        <Col className="admin-header__logo">
          <Link to="/admin">
            <img className={`admin-header__logo-${AppConfig?.hideLogo} admin-header__logo-${identity}`} src={logos[AppConfig.identity]} alt="logo" />
          </Link>
        </Col>
        <Col flex="auto">
          <div className="admin-header__network-filter-wrap">
            <NetworkFilter />
          </div>
        </Col>
        <Col className="admin-header__user">
          <div className="admin-header__controls-wrapper">
            <HeaderUser />
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Header;